import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { cn } from '../../utils/cn';

const BentoCard = ({
  name,
  className,
  background,
  Icon,
  description,
  href,
  cta,
  colSpan = 1,
  rowSpan = 1,
  ...props
}) => {
  const heightClass = rowSpan === 2 ? "h-[560px]" : "h-[280px]";
  
  return (
    <div
      key={name}
      className={cn(
        "group relative flex flex-col overflow-hidden rounded-2xl",
        // Theme styles - black background with border
        "bg-black dark:bg-black border border-gray-200 dark:border-gray-800",
        "transition-all duration-300 hover:border-primary-500",
        // Grid span classes
        colSpan === 2 && "md:col-span-2",
        rowSpan === 2 && "md:row-span-2",
        // Fixed height based on rowSpan
        heightClass,
        className
      )}
      {...props}
    >
      <div className="absolute inset-0">{background}</div>
      <div className="relative p-8 flex flex-col h-full justify-between">
        <div className="pointer-events-none z-10 flex transform-gpu flex-col gap-4 transition-all duration-300 lg:group-hover:-translate-y-2">
          {Icon && (
            <Icon className="h-12 w-12 origin-left transform-gpu text-primary-500 transition-all duration-300 ease-in-out group-hover:scale-75 flex-shrink-0" />
          )}
          <h3 className="text-2xl font-bold text-white">
            {name}
          </h3>
          <p className="text-gray-300 leading-relaxed">{description}</p>
        </div>
        
        <div
          className={cn(
            "pointer-events-none flex w-full translate-y-0 transform-gpu flex-row items-center transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 lg:hidden mt-4"
          )}
        >
          <Link
            to={href}
            className="pointer-events-auto text-primary-500 hover:text-primary-600 transition-colors font-semibold inline-flex items-center gap-2"
          >
            {cta}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
      
      <div
        className={cn(
          "pointer-events-none absolute bottom-0 hidden w-full translate-y-10 transform-gpu flex-row items-center p-8 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 lg:flex"
        )}
      >
        <Link
          to={href}
          className="pointer-events-auto text-primary-500 hover:text-primary-600 transition-colors font-semibold inline-flex items-center gap-2"
        >
          {cta}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      
      <div className="pointer-events-none absolute inset-0 transform-gpu transition-all duration-300 group-hover:bg-primary-500/5" />
    </div>
  );
};

export default BentoCard;

